/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import jApiDataConnectivity from '@/services/jApiDataConnectivity';

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  async setDataConnectivity({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const create = await jApiDataConnectivity.setDataConnectivity(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', create.message, { root: true });
      return create;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },
  async deleteDataConnectivity({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const deleteAuto = await jApiDataConnectivity.deleteDataConnectivity(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', deleteAuto.message, { root: true });
      return deleteAuto;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },
  async verifyDataConnectivity({ dispatch }, req) {
    try {
      const create = await jApiDataConnectivity.verifyDataConnectivity(req);
      return create;
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },
  async getListDataConnectivity({ dispatch }, { reqData, callback }) {
    try {
      const resData = await jApiDataConnectivity.getListDataConnectivity(reqData);
      const res = resData.data.data ? resData.data.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.connection_name;
        res[index].text = lab.connection_name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async findDataConnectivity({ dispatch }, data) {
    let res;
    try {
      res = await jApiDataConnectivity.getListDataConnectivity(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreDataConnectivity.js